import rawNameSuggestions from './nameSuggestions.json'

const normalizeName = (name: string): string => name.trim().toLowerCase()

export const DIGITAL_WORKER_NAME_POOL = Object.freeze([...rawNameSuggestions]) as readonly string[]

export const isSuggestedWorkerName = (name: string): boolean => {
  const normalizedName = normalizeName(name)
  return normalizedName !== '' && DIGITAL_WORKER_NAME_POOL.some((suggestedName) => normalizeName(suggestedName) === normalizedName)
}

export const pickRandomWorkerName = ({ exclude }: { exclude?: string | string[] } = {}): string => {
  const normalizedExcludedNames = new Set(
    (Array.isArray(exclude) ? exclude : [exclude])
      .filter((name): name is string => Boolean(name))
      .map(normalizeName),
  )
  const candidatePool = normalizedExcludedNames.size > 0
    ? DIGITAL_WORKER_NAME_POOL.filter((suggestedName) => !normalizedExcludedNames.has(normalizeName(suggestedName)))
    : DIGITAL_WORKER_NAME_POOL
  const pool = candidatePool.length > 0 ? candidatePool : DIGITAL_WORKER_NAME_POOL

  return pool[Math.floor(Math.random() * pool.length)] ?? ''
}
